import useTrack from "../../game/hooks/use-track";
import { useUserModuleState } from "..";

export function useActiveNode(trackId: TrackId) {
    const { track } = useTrack(trackId);
    const { tracks } = useUserModuleState();

    const memorizedTrackData = tracks.find(t => t.id === trackId);
    const lastVisited = memorizedTrackData?.lastVisited

    if (lastVisited) {
        return track?.nodes.find(n => n.id === lastVisited);
    } else {
        if (track) {
            return track?.nodes.find(n => n.id === track?.startNode);
        }
    }
}
